(function(){
    'use strict'

    angular
    .module('app.empleados')
    .controller('SalarioPromedioMensual', SalarioPromedioMensual);

    SalarioPromedioMensual.$inject = ['$scope', '$animationsSrv', '$routeParams', 'EmpleadosService', 'logger', '$location', 'CoreSrv', 'UserInfoService', 'moment'];

    function SalarioPromedioMensual($scope, $animationsSrv, $routeParams, EmpleadosService, logger, $location, CoreSrv, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.guardando = true;

        vm.salariosMensuales = [];

        vm.salarioMensual = {
            companiaId: UserInfoService.getCompaniaId(),
            empleadoId: $routeParams.id,
            empleadoNombre: $routeParams.nombre,
            anno: moment().year(),
            mes: -1,
            periodo: '',
            montoSalario: 0
        };

        vm.meses = CoreSrv.getMeses();

        vm.getAll = function(){

            var promise = EmpleadosService.getAllSalariosMensuales(vm.salarioMensual.companiaId, vm.salarioMensual.empleadoId);

            promise
            .then(function(salariosMensuales){
                vm.salariosMensuales = salariosMensuales;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los salarios.');
                        break;
                }
            });
        };

        vm.getAll();

        function validateMes(){
            if(vm.salarioMensual.mes == -1){
                $scope.salarioPromedioMensualForm.mes.$setValidity("different", false);
            }
            else{
                $scope.salarioPromedioMensualForm.mes.$setValidity("different", true);
                updatePeriodo();
            }
        };
        
        vm.mesChange = function(){
            validateMes();
        };

        vm.annoChange = function(){
            updatePeriodo();
        };

        function updatePeriodo(){
            vm.salarioMensual.periodo = `${vm.salarioMensual.anno}${vm.salarioMensual.mes < 10 ? '0' + vm.salarioMensual.mes : vm.salarioMensual.mes}`;
        };

        vm.editar = function(salario){
            vm.salarioMensual.anno = salario.anno;
            vm.salarioMensual.mes = salario.mes.toString();
            vm.salarioMensual.periodo = salario.periodo;
            vm.salarioMensual.montoSalario = salario.montoSalario;
            vm.guardando = false;
        };

        vm.save = function(){

            $scope.submitted = true;
            validateMes();

            if($scope.salarioPromedioMensualForm.$valid){
                if(vm.guardando){
                    saveSalarioPromedioMensual();
                }
                else if($scope.salarioPromedioMensualForm.$dirty){
                    updateSalarioPromedioMensual();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveSalarioPromedioMensual() {
            var promise = EmpleadosService.saveSalarioPromedioMensual(vm.salarioMensual);
            
            promise
            .then(function(response){
                logger.success('Salario creado con éxito.');
                vm.getAll();
                clearSalarioPromedioMensualData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el salario: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateSalarioPromedioMensual(){
            var promise = EmpleadosService.updateSalarioPromedioMensual(vm.salarioMensual);
            
            promise
            .then(function(response){
                logger.success('Salario modificado con éxito.');
                vm.getAll();
                clearSalarioPromedioMensualData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el salario: ' + error.data.Message);
                        break;
                }
            });   
        };

        vm.limpiar = function(){
            clearSalarioPromedioMensualData();
        };

        function clearSalarioPromedioMensualData(){
            $scope.submitted = false;
            vm.salarioMensual.montoSalario = 0;
            vm.guardando = true;
            // Set back to pristine.
            $scope.salarioPromedioMensualForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.salarioPromedioMensualForm.$setUntouched();
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.delete = function(salario){
            var promise = EmpleadosService.removeSalarioPromedioMensual(salario);
            
            promise
            .then(function(response){
                vm.salariosMensuales = vm.salariosMensuales.filter(function(g) {
                    return g.periodo !== salario.periodo;
                });
                logger.success('Salario eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el salario');
                        break;
                }
                
            });   
        };

    }
})();